<template>
  <v-layout row justify-center>
    <v-dialog attach="main" v-model="show" content-class="config-page" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card tile color="bgColor">
        <v-toolbar fixed height="50px" card dark color="primary">
          <v-toolbar-title class="d-flex">
            <v-icon class="mr-1">settings</v-icon>Configurações</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <template>
          <v-container grid-list-lg class="pt-4 mt-4 config-wrapper" fluid>
            <v-layout row wrap class="pt-4">
               <v-flex xs12 sm4>
                 <v-card class="card-edit">
                  <v-card-title primary-title class="py-0 px-0 title-color">
                    <v-card-text class="py-2">
                      <h2 class="subheading">Campos Extras</h2>
                    </v-card-text>
                  </v-card-title>
                  <v-divider></v-divider>
                  <form-config @save="saveFields" displayMode actionsEdit :items="config" />
                 </v-card>
               </v-flex>
               <v-flex xs12 sm8>
                 <v-card class="card-edit">
                  <v-card-title primary-title class="py-0 px-0 title-color">
                    <v-card-text class="py-2">
                      <h2 class="subheading">Centro de custo</h2>
                    </v-card-text>
                  </v-card-title>
                  <v-divider></v-divider>
                  <cost-center />
                 </v-card>
               </v-flex>
            </v-layout>
          </v-container>
        </template>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import FormConfig from '@/components/ui/forms/FormConfig'
import CostCenter from '@/components/ui/costCenter/Index'

export default {
  name: 'Configuration',
  components: { FormConfig, CostCenter },
  data () {
    return {
      show: false,
      routerName: '',
      updateRouter: {},
      config: {
        agreement: '34234987',
        cardNumber: '123123123',
        code: '9879889'
      }
    }
  },
  methods: {
    close () {
      let routerName = this.routerName
      let params = this.updateRouter.params
      this.show = false
      this.$router.push({ name: routerName, params })
    },
    checkRoute () {
      if (this.$route.params.routeName === undefined) {
        this.routerName = 'Dashboard'
      } else {
        this.routerName = this.$route.params.routeName
        this.updateRouter = Object.assign({}, this.$route)
      }
    },
    saveFields (val) {
      console.log('saveFields', val)
      this.$root.$emit('snackbar', { show: true, color: 'success', text: 'Atualizado com sucesso' })
    }
  },
  mounted () {
    this.checkRoute()
    this.show = true
  },
  beforeDestroy () {
    this.show = false
  }
}
</script>

